module.exports = __webpack_public_path__ + "static/inside_video_main_s3-b745b616f828e2339acb5a5bbd6861ce.mp4";